import { useParksViewContext } from "provider/ParkViewProvider";
import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import path from "assets/img/locationpath.svg";
import print from "assets/img/printP.png";
import rupees from "assets/img/rupees.png";
import plan from "assets/img/planpath.svg";
import bugy from "assets/img/bugeypath.svg";
import bus from "assets/img/buspath.svg";
import lock from "assets/img/lockpath.png";
import nightMode from "assets/img/nightmodepath.png";
import rupeeFormat from "components/Api/RupeeFormat";
import CorrectionModal from "./modal/CorrectionModal";
import { common } from "Data/common";
const PARKVIEW = common?.ALL_PARKS?.PARK_VIEW;


const ParkMainOverView = () => {
  const { parkDetail, suggCorrToggle, parksViewDispatch } = useParksViewContext();


  const handleModalClose = () => {
    parksViewDispatch({
      type: "SET_PARK_VIEW_CORRECTION_SUGGESTION_TOGGLE",
      payload: false,
    });
  };
  return (
    <>
      <Row className="justify-content-center">
        <Col xxl={10} xl={12} lg={12}>
          <Row className="mb-2">
            <Col
              xl="auto"
              lg="auto"
              md={12}
              sm={12}
              xs={12}
              className="col-2-5"
              style={{ borderBottom: "1px solid #0000004D" }}
            >
              <div className="tiger_images pt-2 park-dp" >
                <img
                  src={parkDetail?.feature_image_path}
                  alt=""
                  className="w-100 h-100"
                />
              </div>
            </Col>
            <Col
              xl="auto"
              lg="auto"
              md={12}
              sm={12}
              xs={12}
              className="col-8-5 pt-4"
              style={{ borderBottom: "1px solid #0000004D" }}
            >
              <div className="main_parent d-flex justify-content-between">
                <div className="title d-flex gap-4">
                  <h3>{parkDetail?.about_title}</h3>
                  {/* <div className="follow mb-lg-2 mb-xxl-0 mb-2">
                    <Link
                      className="parkrevieBtn"
                      to="/operator/ankit-kankane-safaris/follow"
                      data-pjax="0"
                    >
                      {" "}
                      Follow
                    </Link>
                  </div> */}
                </div>
                <div className="right_button float-lg-end pb-2 d-lg-block d-flex justify-content-end">
                  <OverlayTrigger
                    placement="top"
                    container={document.body}
                    overlay={
                      <Tooltip id="tooltip-top" className="custom-tooltip">
                        {PARKVIEW?.TOOL_TEXT}
                      </Tooltip>
                    }
                  >
                    <span className="d-inline-block"> {/* Ensures stable target for tooltip */}
                      <Button
                        variant="link"
                        className="btn-exclamation pe-1 writeSuggestionBtn"
                        onClick={() => {
                          parksViewDispatch({
                            type: "SET_PARK_VIEW_CORRECTION_SUGGESTION_TOGGLE",
                            payload: true,
                          });
                        }}
                        style={{ padding: 0 }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="30"
                          viewBox="0 0 512 512"
                          style={{ cursor: "pointer" }}
                          aria-hidden="true"
                          focusable="false"
                        >
                          <g>
                            <path
                              d="M507.494 426.066 282.864 53.537a31.372 31.372 0 0 0-53.73 0L4.506 426.066a31.37 31.37 0 0 0 26.864 47.569h449.259a31.372 31.372 0 0 0 26.865-47.569zM256.167 167.227c12.901 0 23.817 7.278 23.817 20.178 0 39.363-4.631 95.929-4.631 135.292 0 10.255-11.247 14.554-19.186 14.554-10.584 0-19.516-4.3-19.516-14.554 0-39.363-4.63-95.929-4.63-135.292 0-12.9 10.584-20.178 24.146-20.178zm.331 243.791c-14.554 0-25.471-11.908-25.471-25.47 0-13.893 10.916-25.47 25.471-25.47 13.562 0 25.14 11.577 25.14 25.47 0 13.562-11.578 25.47-25.14 25.47z"
                              fill="#585757"
                            />
                          </g>
                        </svg>
                      </Button>
                    </span>
                  </OverlayTrigger>

                </div>
                <div id="flashMessage" style={{ display: "none" }}>
                  {PARKVIEW?.TOOL_TEXT}
                </div>
              </div>
              <div className="detailesOrLocation">
                <Row className="">
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={path} alt="" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.LOCATION}</span>
                        <span className="titles_filed">
                          {`${parkDetail?.state?.state_name}, ${parkDetail?.location?.title}`}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={bus} alt="" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.RAILWAY}</span>
                        <span className="titles_filed">
                          {parkDetail?.railway_station_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={plan} alt="" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.AIRPORT}</span>
                        <span className="titles_filed">
                          {parkDetail?.airport?.name}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={bugy} alt="" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.SAFARI_MODE}</span>
                        <span className="titles_filed">
                          {parkDetail?.safari_vehicles_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={nightMode} alt="" style={{ height: "16px" }} />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.SESSION}</span>
                        <span className="titles_filed">
                          {parkDetail?.safari_sessions_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={print} alt="" style={{ height: "16px" }} />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.WILD_LIFE}</span>
                        <span className="titles_filed">
                          {`${parkDetail?.state?.state_name}, ${parkDetail?.location?.title}`}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={rupees} alt="" style={{ height: "14px" }} className="iconTop mt-1" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.COST}</span>
                        <span className="titles_filed">
                          {`${rupeeFormat(
                            parkDetail?.avg_safari_price_min
                          )} - ${rupeeFormat(parkDetail?.avg_safari_price_max)}`}
                          <span className="avg_price">{PARKVIEW?.PRICE}</span>
                        </span>
                        <span className="avg_price_condition">{PARKVIEW?.OPERATOR}</span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={lock} alt="" style={{ height: "16px" }} />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">{PARKVIEW?.MONTH}</span>
                        <span className="titles_filed">
                          {parkDetail?.locked_months_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {suggCorrToggle && <CorrectionModal handleClose={handleModalClose} />}
    </>
  );
};

export default ParkMainOverView;
